<template>
  <div>
    <a-page-header
      style="border: 1px solid rgb(235, 237, 240);background: #ffffff"
      title="网站探索"
      :breadcrumb=" { props: { routes:[{path:'/',breadcrumbName:$t('HOME')}
      ,{path:'/website-news',breadcrumbName:'网站探索列表'}
      ,{path:`/website-news/${newsId}`,breadcrumbName:'探索详情'}
      ] } }"
    />
    <div style="position: relative">
      <a-menu :defaultSelectedKeys="['content']" mode="horizontal">
        <a-menu-item
          key="detail"
          @click="()=>{this.$router.push(`/website-news/${newsId}`)}">
          <a-icon type="mail"/>
          网站探索
        </a-menu-item>
        <a-menu-item
          key="content"
          @click="()=>{this.$router.push(`/website-news/${newsId}/content`)}">
          <a-icon type="mail"/>
          探索详情
        </a-menu-item>
      </a-menu>
    </div>
    <a-card style="margin: 16px" :bordered="false">
      <div>
        <website-article-detail entity-type="WEBSITE_NEWS" :entity-id="newsId"/>
      </div>
    </a-card>
  </div>
</template>

<script>
import { _addNews, _queryNews, _updateNews, } from '@/api/websiteNewsApi';
import WebsiteArticleDetail from '@/components/websiteArticleDetail/WebsiteArticleDetail.vue';

async function getNews() {
  const result = await _queryNews(this.newsId);
  if (result) {
    this.form.data.title = result.title;
    this.form.data.styleType = result.styleType;
    this.form.data.categoryId = result.categoryId;
    this.form.data.coverPath = result.coverPath;
    this.form.data.topImage = result.topImage;
    this.form.data.code = result.code;
    this.form.data.subTitle = result.subTitle;
    this.form.data.tip = result.tip;
    this.form.data.description = result.description;
    this.form.data.color = result.color;
    this.form.data.images = result.images ? result.images.split('|') : [];
  }
}

async function onAdd() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _addNews({
        title: this.form.data.title,
        styleType: this.form.data.styleType,
        categoryId: this.form.data.categoryId,
        coverPath: this.form.data.coverPath,
        tip: this.form.data.tip,
        topImage: this.form.data.topImage,
        code: this.form.data.code,
        subTitle: this.form.data.subTitle,
        description: this.form.data.description,
        color: this.form.data.color,
        images: this.form.data.images.join('|'),
      });
      if (result) {
        this.$message.success(this.$t('ADD_SUCCESS'));
        this.$router.push('/website-news');
      }
    }
  });
}

async function onUpdate() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _updateNews(this.newsId, {
        title: this.form.data.title,
        styleType: this.form.data.styleType,
        categoryId: this.form.data.categoryId,
        tip: this.form.data.tip,
        coverPath: this.form.data.coverPath,
        topImage: this.form.data.topImage,
        code: this.form.data.code,
        subTitle: this.form.data.subTitle,
        description: this.form.data.description,
        color: this.form.data.color,
        images: this.form.data.images.join('|'),
      });
      if (result) {
        this.$message.success('更新成功');
      }
    }
  });
}

function onCancel() {
  if (this.onCancelHandler) {
    this.onCancelHandler();
  }
}

export default {
  name: 'WebsiteNewsDetail',
  components: {
    WebsiteArticleDetail,
  },
  props: {
    newsId: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
  },
  watch: {
    newsId() {
      if (this.newsId) {
        this.getNews();
      }
    },
  },
  methods: {
    onAdd,
    onUpdate,
    onCancel,
    getNews,
  },
  data() {
    return {
      form: {
        data: {
          title: '',
          categoryId: '',
          coverPath: '',
          topImage: '',
          styleType: 'NORMAL',
          code: '',
          color: '',
          subTitle: '',
          description: '',
          images: [],
        },
        rules: {
          title: [{
            required: true,
            trigger: 'blur'
          }],
          coverPath: [{
            required: true,
            trigger: 'blur'
          }],
          code: [{
            required: true,
            trigger: 'blur'
          }],
          subTitle: [{
            required: true,
            trigger: 'blur'
          }],
          description: [{
            required: true,
            trigger: 'blur'
          }],
          images: [{
            required: true,
            trigger: 'blur'
          }],
        },
        title: '',
      },
    };
  },
  created() {
    if (this.newsId) {
      this.getNews();
    }
  },
};
</script>
